import { SERVER_CONFIG_LOADED, SERVER_ERROR, SET_ENVID,CLEAR_ERROR } from '../actions/serverManagerAction'

const initialState = {
    authUrl:'',
    apiUrl:'',
    initialized:false,
    error:null,
    onModalClose:undefined
};

const server = (state = initialState, action)=> {
    switch (action.type) {
        case SERVER_CONFIG_LOADED: {
            const { AuthUrl, ApiUrl} = action.payload;
            
            return {
                ...state,
                authUrl:AuthUrl ,
                apiUrl:ApiUrl,
                initialized:true,
                error:null
              }
        }

        case SERVER_ERROR: {
            const {error ,onModalClose} = action;            
            return {
                ...state,                
                error:error,
                onModalClose:onModalClose
              }
        }

        case SET_ENVID: {
            const {envID } = action;            
            return {
                ...state,                
                envID:envID
              }
        }

        case CLEAR_ERROR: {                       
            return {
                ...state,                
                error:null,
                onModalClose:undefined
              }
        }

        default:
            return state;
    }

}

export default server